// Environment configuration for CommonChord

export interface AppConfig {
  apiUrl: string;
  websocketUrl: string;
  environment: string;
  projectVersion: string;
  deploymentId: string;
  isDevelopment: boolean;
  isProduction: boolean;
}

const getConfig = (): AppConfig => {
  const environment = import.meta.env.VITE_ENVIRONMENT || import.meta.env.MODE || 'development';
  const isDevelopment = environment === 'development';
  const isProduction = environment === 'production';

  // Default URLs for development
  let apiUrl = 'http://localhost:3001';
  let websocketUrl = 'ws://localhost:3002';

  // Use environment variables if provided (for deployment)
  if (import.meta.env.VITE_API_URL) {
    apiUrl = import.meta.env.VITE_API_URL;
  } else if (import.meta.env.VITE_API_ENDPOINT) {
    apiUrl = import.meta.env.VITE_API_ENDPOINT;
  }

  if (import.meta.env.VITE_WEBSOCKET_URL) {
    websocketUrl = import.meta.env.VITE_WEBSOCKET_URL;
  } else if (import.meta.env.VITE_WEBSOCKET_ENDPOINT) {
    websocketUrl = import.meta.env.VITE_WEBSOCKET_ENDPOINT;
  }

  return {
    apiUrl,
    websocketUrl,
    environment,
    projectVersion: import.meta.env.VITE_PROJECT_VERSION || 'v1-mvp',
    deploymentId: import.meta.env.VITE_DEPLOYMENT_ID || 'fix-2025-01-02',
    isDevelopment,
    isProduction,
  };
};

export const config = getConfig();

// Helper function to get the QR code join URL
export const getJoinUrl = (sessionId: string): string => {
  // In production, use the current domain
  if (config.isProduction && typeof window !== 'undefined') {
    return `${window.location.origin}/join/${sessionId}`;
  }
  
  // In development, use localhost
  return `http://localhost:3000/join/${sessionId}`;
};

// Debug logging - always log in non-production to help diagnose issues
if (!config.isProduction || config.isDevelopment) {
  console.log('🔧 CommonChord Configuration:', {
    ...config,
    apiUrl: config.apiUrl || '[NOT SET]',
    websocketUrl: config.websocketUrl || '[NOT SET]',
    environment: config.environment,
    isDevelopment: config.isDevelopment,
    isProduction: config.isProduction,
    // Log what environment variables were available during build
    availableEnvVars: {
      VITE_API_URL: import.meta.env.VITE_API_URL || '[NOT SET]',
      VITE_WEBSOCKET_URL: import.meta.env.VITE_WEBSOCKET_URL || '[NOT SET]',
      VITE_API_ENDPOINT: import.meta.env.VITE_API_ENDPOINT || '[NOT SET]',
      VITE_WEBSOCKET_ENDPOINT: import.meta.env.VITE_WEBSOCKET_ENDPOINT || '[NOT SET]',
      VITE_ENVIRONMENT: import.meta.env.VITE_ENVIRONMENT || '[NOT SET]',
    }
  });
}